module.exports = __webpack_public_path__ + "img/line_logo.44ed4187.svg";